import React, { PureComponent } from 'react';

import numeral from '../../../../node_modules/numeraljs/numeral.js';
import {
  Error
} from './../../Utils/Utils.js';

class RecentNewsletters extends PureComponent {
  renderRows(data) {

    return data.data.map(function (row, key) {
      return ([
        <tr key={key} >
          <td className="text-left">
            <span className="table-with-content__text">
              <div className="table-with-content__label">{row.label}</div>
            </span>
          </td>
          <td className="text-left">{numeral(row.sent_count).format('0.0a')}</td>
          <td className="text-center">{numeral(row.open_rate).format('0.0')}%</td>
          <td className="text-center">{numeral(row.click_rate).format('0.0')}%</td>
        </tr>,
        <tr key={key + 1}>
          <td className="align-top">
            <span className="table-with-content__text">
              <div className="text-muted">{row.date}</div>
            </span>
          </td>
          <td colSpan="4">
            <span className="table-with-content__link"><span className="text-muted">Most Clicked: </span><a href={row.most_clicked} target="_blank" rel="noopener noreferrer">
              {row.most_clicked.split('?')[0]}
            </a>
            </span>
          </td>
        </tr>
      ]);
    });

    
  }

  render() {
    let { data } = this.props;
    
    if (data.hasData === false) {
      return <Error minHeight={360} />
    }

    const columnWidth = {
      width: "220px"
    }

    return (

      <div className="react-bs-table-container">
        <table className="table-responsive table-with-content">
          <thead>
            <tr>
              <th className="text-left pl-0" style={columnWidth}>Newsletter</th>
              <th className="text-left pl-0">Subs</th>
              <th>Opens</th>
              <th>Clicks</th>
            </tr>
          </thead>
          <tbody>
            {this.renderRows(data)}
          </tbody>
        </table>
      </div>
    );
  }
}


export default RecentNewsletters
